(ns app.front.view.group.admin.letter.inspection-snippet-editor
  (:require [app.domain.inspection.model :as inspection-model]
            [app.domain.letter.model :as letter-model]
            [app.front.ui.text-editor :as text-editor]
            [app.front.view.group.admin.templates.document-editor :as document-editor])
  (:require-macros [core.util.util :as util]))

(def inspection-editor-data
  [{:title                    :letter/no-access-inspection-snippet
    :inspection-fragment      :letter-fragment/no-access-inspection-snippet
    :visit-fragment           :letter-fragment/no-access-inspection-visit-snippet
    :inspector-fragment       :letter-fragment/no-access-inspection-inspector-snippet
    :checklist-table-fragment :letter-fragment/no-access-inspection-checklist-table-snippet
    :checklist-fragment       :letter-fragment/no-access-inspection-checklist-snippet
    :checklist-group-fragment :letter-fragment/no-access-inspection-checklist-group-snippet
    :checklist-item-fragment  :letter-fragment/no-access-inspection-checklist-item-snippet
    :deficiency-fragment      :letter-fragment/no-access-inspection-deficiency-snippet
    :photo-fragment           :letter-fragment/no-access-inspection-photo-snippet}
   {:title                    :letter/not-complete-inspection-snippet
    :inspection-fragment      :letter-fragment/not-complete-inspection-snippet
    :visit-fragment           :letter-fragment/no-access-inspection-visit-snippet
    :inspector-fragment       :letter-fragment/not-complete-inspection-inspector-snippet
    :checklist-table-fragment :letter-fragment/not-complete-inspection-checklist-table-snippet
    :checklist-fragment       :letter-fragment/not-complete-inspection-checklist-snippet
    :checklist-group-fragment :letter-fragment/not-complete-inspection-checklist-group-snippet
    :checklist-item-fragment  :letter-fragment/not-complete-inspection-checklist-item-snippet
    :deficiency-fragment      :letter-fragment/not-complete-inspection-deficiency-snippet
    :photo-fragment           :letter-fragment/not-complete-inspection-photo-snippet}
   {:title                    :letter/failed-inspection-snippet
    :inspection-fragment      :letter-fragment/failed-inspection-snippet
    :visit-fragment           :letter-fragment/failed-inspection-visit-snippet
    :inspector-fragment       :letter-fragment/failed-inspection-inspector-snippet
    :checklist-table-fragment :letter-fragment/failed-inspection-checklist-table-snippet
    :checklist-fragment       :letter-fragment/failed-inspection-checklist-snippet
    :checklist-group-fragment :letter-fragment/failed-inspection-checklist-group-snippet
    :checklist-item-fragment  :letter-fragment/failed-inspection-checklist-item-snippet
    :deficiency-fragment      :letter-fragment/failed-inspection-deficiency-snippet
    :photo-fragment           :letter-fragment/failed-inspection-photo-snippet}
   {:title                    :letter/passed-inspection-snippet
    :inspection-fragment      :letter-fragment/passed-inspection-snippet
    :visit-fragment           :letter-fragment/passed-inspection-visit-snippet
    :inspector-fragment       :letter-fragment/passed-inspection-inspector-snippet
    :checklist-table-fragment :letter-fragment/passed-inspection-checklist-table-snippet
    :checklist-fragment       :letter-fragment/passed-inspection-checklist-snippet
    :checklist-group-fragment :letter-fragment/passed-inspection-checklist-group-snippet
    :checklist-item-fragment  :letter-fragment/passed-inspection-checklist-item-snippet
    :deficiency-fragment      :letter-fragment/passed-inspection-deficiency-snippet
    :photo-fragment           :letter-fragment/passed-inspection-photo-snippet}])

(defn inspection-snippet-editor [{:keys [title
                                         inspection-fragment
                                         visit-fragment
                                         inspector-fragment
                                         checklist-table-fragment
                                         checklist-fragment
                                         checklist-group-fragment
                                         checklist-item-fragment
                                         deficiency-fragment
                                         photo-fragment]}
                                 {:keys [get-external-edit-state-key
                                         permit-type
                                         tr
                                         images
                                         group
                                         group-id
                                         document-id
                                         group-features
                                         inherited?
                                         feature-flags]}]
  [document-editor/editor
   (-> (util/mmap {:title              [:h4 (tr [title])]
                   :read-only?         inherited?
                   :placeholders       (if (= permit-type :permit-type/CE)
                                         letter-model/all-inspection-variables-ce
                                         letter-model/all-inspection-variables)
                   :small?             true
                   :html-fragment-type inspection-fragment}
                  tr images group-id document-id)
       (text-editor/with-external-edit-state (get-external-edit-state-key inspection-fragment)))
   [:<>
    [document-editor/editor
     (-> (util/mmap {:title              [:h4 (tr [:letter/inspection-visit-snippet])]
                     :read-only?         inherited?
                     :placeholders       letter-model/all-visit-variables
                     :small?             true
                     :html-fragment-type visit-fragment}
                    tr images group-id document-id)
         (text-editor/with-external-edit-state (get-external-edit-state-key visit-fragment)))
     [document-editor/editor
      (-> (util/mmap {:title              [:h4 (tr [:letter/inspector-snippet])]
                      :read-only?         inherited?
                      :placeholders       letter-model/inspector-snippet-variables
                      :small?             true
                      :html-fragment-type inspector-fragment}
                     tr images group-id document-id)
          (text-editor/with-external-edit-state (get-external-edit-state-key inspector-fragment)))]]
    (when (inspection-model/has-checklists-v2? group-features feature-flags)
      [document-editor/editor-for-snippet
       (letter-model/checklist-snippet-config
         :fragment-reference
         checklist-table-fragment
         checklist-fragment
         checklist-group-fragment
         checklist-item-fragment)
       (util/mmap {:read-only? inherited?} tr document-id group-id)])
    [document-editor/editor
     (-> (util/mmap {:title              [:h4 (tr [:letter/inspection-deficiency-snippet])]
                     :read-only?         inherited?
                     :placeholders       (letter-model/deficiency-snippet-variables group feature-flags)
                     :small?             true
                     :html-fragment-type deficiency-fragment}
                    tr images group-id document-id)
         (text-editor/with-external-edit-state (get-external-edit-state-key deficiency-fragment)))]
    [document-editor/editor
     (-> (util/mmap {:title              [:h4 (tr [:letter/inspection-photo-snippet])]
                     :read-only?         inherited?
                     :placeholders       (letter-model/photo-snippet-variables feature-flags)
                     :small?             true
                     :html-fragment-type photo-fragment}
                    tr images group-id document-id)
         (text-editor/with-external-edit-state (get-external-edit-state-key photo-fragment)))]]])

(defn inspection-snippets-editor [{:keys [visible-fragment-types] :as ctx}]
  (->> inspection-editor-data
       (keep (fn [editor-data]
               (when (contains? visible-fragment-types (:inspection-fragment editor-data))
                 [inspection-snippet-editor editor-data ctx])))
       (into [:<>])))
